
<template>
  <div
    class="modal fade"
    id="createUserTypeModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createRankTypeModalLabel"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <form
        class="modal-content"
        @submit="addUserType"
      >
        <div class="modal-header">
          <h5
            class="modal-title"
            id="createRankTypeModalLabel"
          >
            ADD NEW USER TYPE
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div
            class="form-group row"
            :class="{'has-error': errorCreateUserType.code !== ''}"
          >
            <label
              for="newUserTypeCode"
              class="col col-sm-2 col-form-label font-weight-bolder"
            >CODE:</label>
            <div class="col col-sm-10">
              <input
                type="text"
                id="newUserTypeCode"
                class="form-control"
                placeholder="USER TYPE CODE"
                v-model="newUserType.code"
                @input="capitalize($event, newUserType, 'code')"
              >
              <span
                class="help-block"
                v-if="errorCreateUserType.code !== ''"
              >
                <small><strong>{{ errorCreateUserType.code }}</strong></small>
              </span>
            </div>
          </div>

          <div
            class="form-group row"
            :class="{'has-error': errorCreateUserType.name !== ''}"
          >
            <label
              for="newUserTypeName"
              class="col col-sm-2 col-form-label font-weight-bolder"
            >NAME:</label>
            <div class="col col-sm-10">
              <input
                type="text"
                id="newUserTypeName"
                class="form-control"
                placeholder="USER TYPE NAME"
                v-model="newUserType.name"
                @input="capitalize($event, newUserType, 'name')"
              >
              <span
                class="help-block"
                v-if="errorCreateUserType.name !== ''"
              >
                <small><strong>{{ errorCreateUserType.name }}</strong></small>
              </span>
            </div>
          </div>

          <div class="form-group row">
            <label
              for="newRankTypeStatus"
              class="col col-sm-2 col-form-label font-weight-bolder"
            >STATUS:</label>
            <div class="col col-sm-2">
              <input
                type="checkbox"
                name="newRankTypeStatus"
                id="newRankTypeStatus"
                class="form-control"
                v-model="newUserType.status"
              >
            </div>

            <div class="col col-sm-2 col-form-label font-weight-bold">
              <label>{{ newUserType.status ? 'ACTIVE':'INACTIVE' }}</label>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-success font-weight-bolder">
            Create
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { formMixins } from "../../../mixins/formMixins";
    export default {
        mixins: [formMixins],
        name: 'CreateUserType',
        methods: {
            ...mapActions(['createUserType']),

            async addUserType(e) {
                e.preventDefault();
                if(await this.confirmCreateAlert('Are you sure you want to add this User Type?')) {
                    this.createUserType(this.newUserType);
                }
            }
        },

        computed: {
            ...mapGetters([
                'newUserType',
                'errorCreateUserType'
            ])
        }
    };
</script>

<style scoped>

</style>
